import { UserManager } from "oidc-client";


const cognitoAuthConfig = {
    authority: process.env.AWS_AUTHORITY || `https://cognito-idp.ap-southeast-1.amazonaws.com/ap-southeast-1_16QK44QCP`,
    client_id: process.env.AWS_CLIENT_ID || "6jfoi4m75nt73u5fgpvvbfjv0c",
    // redirect_uri: "https://portal-dev.ilog.ai",
    redirect_uri: process.env.AWS_REDIRECT_URI,
    // redirect_uri: "http://localhost:8080",
    response_type: "code",
    // scope: "email openid phone aws.cognito.signin.user.admin",
    scope: "email openid phone",
    loadUserInfo: true,
};

// Create a UserManager instance
export const userManager = new UserManager({
    authority: cognitoAuthConfig.authority,
    client_id: cognitoAuthConfig.client_id,
    redirect_uri: cognitoAuthConfig.redirect_uri,
    response_type: cognitoAuthConfig.response_type,
    scope: cognitoAuthConfig.scope,
});

// Sign out and redirect to logout page
export function signOutRedirect() {
    const clientId = cognitoAuthConfig.client_id;
    const logoutUri = process.env.AWS_REDIRECT_URI;
    const cognitoDomain = process.env.COGNITO_DOMAIN || "https://ap-southeast-116qk44qcp.auth.ap-southeast-1.amazoncognito.com";

    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
}



//////////////////
// WEBPACK FOOTER
// ./config/auth.js
// module id = null
// module chunks = 